import api from '@/utils/axios';
import { unwrapList } from '@/utils/apiHelpers';
import type { ApiUser } from './types';

export interface TypeUsersFilters {
  zone_id?: number;
  status?: string;
  search?: string;
  phone?: string;
}

export async function listUsersByType(typeId: number, filters?: TypeUsersFilters): Promise<ApiUser[]> {
  const res = await api.get(`/types/${typeId}/users`, { params: filters });
  return unwrapList<ApiUser>(res.data);
}
